var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0044C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1761 8.5332C13.7159 8.5332 11.5324 9.71099 10.153 11.5199H10.1368V11.5403C9.19311 12.7867 8.62695 14.3276 8.62695 15.9999C8.62695 20.1148 12.0158 23.4665 16.1761 23.4665C20.3365 23.4665 23.7253 20.1148 23.7253 15.9999C23.7253 11.885 20.3365 8.5332 16.1761 8.5332ZM18.4408 10.4626C20.6566 11.3462 22.2154 13.4856 22.2154 15.9999C22.2154 17.5588 21.6119 18.9703 20.6289 20.0322C20.4357 19.4276 19.871 18.9865 19.1957 18.9865C18.779 18.9865 18.4408 18.652 18.4408 18.2399V16.7465C18.4408 16.3344 18.1026 15.9999 17.6859 15.9999H14.6662C14.2495 15.9999 13.9113 15.6654 13.9113 15.2532C13.9113 14.841 14.2495 14.5065 14.6662 14.5065C15.0829 14.5065 15.4211 14.172 15.4211 13.7599V13.0132C15.4211 12.601 15.7593 12.2665 16.1761 12.2665H16.931C17.7652 12.2665 18.4408 11.5983 18.4408 10.7732V10.4626ZM13.9114 18.24L10.2932 14.6613C10.1939 15.0921 10.1369 15.5387 10.1369 16C10.1369 19.0544 12.4362 21.5561 15.4213 21.9223V20.48C14.5871 20.48 13.9114 19.8117 13.9114 18.9867V18.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteSocial);
export default __webpack_public_path__ + "static/media/Website_social.d2086fa0c806248f3d4bdcd6f86d8ab9.svg";
export { ForwardRef as ReactComponent };